<!-- 看板 -->
<template>
    <!-- 统计分析 -->
    <div>
        <div class="toolbar">
            <el-form :inline="true" ref="query" :model="query" label-width="70px">
                <el-form-item label="部门">
                    <el-select v-model="query.dept" placeholder="请选择" style="width: 180px">
                        <el-option v-for="item in deptList" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="日期">
                    <el-date-picker v-model="query.day" type="date" clearable placeholder="请选择日期"
                        class="short-width"></el-date-picker>
                </el-form-item>
                <el-form-item class="leftmargin">
                    <el-button type="primary" icon="el-icon-search" @click="getData">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-row>
            <div v-loading="loading" element-loading-text="拼命加载中......">
                <el-table :data="dataList" style="width: 100%;min-height: 500px;" :row-style="tableRowStyle"
                    :header-cell-style="tableHeaderColor">
                    <el-table-column label="员工姓名" width="150" align="center" prop="username" />
                    <el-table-column label="日期" min-width="180" align="center" prop="day" />
                    <el-table-column label="早打卡时间" min-width="180" align="center" prop="morning" />
                    <el-table-column label="晚打卡时间" min-width="180" align="center" prop="night" />
                    <el-table-column label="状态" width="150" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.status }}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="150" align="center">
                        <template slot-scope="scope">
                          <el-button type="waring" size="mini" plain 
                            @click="handleDetail(scope.$index, scope.row)">详情</el-button>
                        </template>
                      </el-table-column>
                </el-table>
            </div>
        </el-row>
    </div>
</template>
    
<script>
export default {
    name: 'kaoqing',
    data() {
        return {
            query: {
                pageNum: 1,
                pageSize: 10,
                dept: "",
                day: "",
            },
            deptList: [],
            dataList: [],
            loading: false,
        };
    },
    created() {
        this.getData();
    },
    methods: {
        getData() {

        },
        clean() {

        },
        // 修改table tr行的背景色
        tableRowStyle({ row, rowIndex }) {
            return "background-color: #ffffff";
        },
        // 修改table header的背景色
        tableHeaderColor({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 14px;background-color: #d4f5fa;";
            }
        },
        handleDetail(index,row){

        },
    }
};
</script>
    
    
<style scoped>
.toolbar {
    padding-left: 8px;
    padding-top: 5px;
}

.el-row {
    margin-bottom: 20px;
}

.short-width {
    width: 150px;
}

.common-width {
    width: 200px;
}

.schart {
    width: 100%;
    height: 300px;
}
</style>
    